import { baseSelectors } from 'store/modules/Base/selectors';
import { metaSelectors } from 'store/modules/Meta/selectors';
import { authSelectors } from 'store/modules/Auth/selectors';
import { caseSelectors } from 'store/modules/Case/selectors';
import { customersSelectors } from 'store/modules/Customers/selectors';
import { portfolioBuilderSelectors } from 'store/modules/PorfolioBuilder/selectors';
import { IPSSelectos } from 'store/modules/IPS/selectors';
import { questionnareSelectors } from 'store/modules/Quesionnare/selectors';
import { firmSelectors } from 'store/modules/Firm/selectors';
import { messagesSelectors } from './modules/WebSocket/selectors';
import { advisorSelectors } from './modules/Advisor/selectors';
import { importingPoliciesSelectors } from './modules/PolicyImport/selectors';
import { dragAndDropSelectors } from './modules/DragAndDrop/selector';
import { fundsAndMpsRefSelectors } from './modules/FundsAndMpsCipRef/selectors';
import { riskMappingSelectors } from './modules/RiskMapping/selectors';
import { capacityForLossSelectors } from './modules/CapacityForLoss/selectors';
import { experienceSelectors } from './modules/Experience/selectors';
import { reportSelectors } from './modules/Report/selectors';
import { cipSelectors } from './modules/CIP/selectors';
import { investmentAnalyserSelectors } from './modules/InvestmentAnalyser/selectors';

export default {
  baseSelectors,
  metaSelectors,
  authSelectors,
  caseSelectors,
  customersSelectors,
  portfolioBuilderSelectors,
  IPSSelectos,
  questionnareSelectors,
  firmSelectors,
  messagesSelectors,
  advisorSelectors,
  importingPoliciesSelectors,
  dragAndDropSelectors,
  fundsAndMpsRefSelectors,
  riskMappingSelectors,
  capacityForLossSelectors,
  reportSelectors,
  cipSelectors,
  investmentAnalyserSelectors,
  experienceSelectors
};
